import {createApp} from "vue";
import {i18n} from "./lang";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Directives from "./directive";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import Icon from "./components/Icon.vue";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import en from 'element-plus/dist/locale/en.mjs'
import "@/utils/cleanRest.js"
import "@/utils/wangEditor/wangEditor.min"
import vue3videoPlay from "vue3-video-play"; // 引入组件
import "vue3-video-play/dist/style.css"; // 引入css
import "@/utils/string/index";
import {Button, Steps} from 'ant-design-vue';
// import { initChat } from './chat';
// 自定义指令
import {directiveM, loadMore} from '@/directive/tablescroll'
import selectLoadMore from '@/directive/loadmore.js';
// global css
import "./less/index.less";
import "./less/scroll.less";
// notify less
import '@/utils/notifies/emailMessage.less'
// 主题颜色
import "@/less/theme/them.less"
import "@/assets/css/index.css"
// permission control
import "./permission";
// utils
import {DateFormat} from "@/utils/util";
import {Storage} from "@/utils/storage"
import sessionStore from "@/utils/sessionStore";
import {UserTable} from "@/views/Marketing/db_user";
import {CustomerTable} from "@/views/Marketing/db_customer";

/**
 * 生产环境配置
 */
// 去除所有 waring 和 console
console.warn = () => {
};
console.log(process.env.NODE_ENV, 'ENV')
if (process.env.NODE_ENV === "production") {
    console.log = () => {
    };
    console.warn = () => {
    };
}

const VUE_APP_VERSION = require('../package.json').version;
const vers = Storage.get('appVersion');
if (VUE_APP_VERSION !== vers) {
    try {
        // Storage.clear()
        Storage.set('appVersion', VUE_APP_VERSION);
        UserTable.clear()
        CustomerTable.clear()
        // sessionStore.clear()
        sessionStore.remove("globalSelectedRows")
        sessionStore.remove("selectedRows")
        sessionStore.remove("shouldShowSideBar")
        sessionStore.remove("sumData")
        sessionStore.remove("userIsAdmin")
        // 清除存储在浏览器的数据
        Storage.remove("UserInfoForGUID")
        Storage.remove("spaceSize")
        // Storage.remove("tinymce-default-font-family")
        location.reload()
    } catch (e) {

    }
}

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */

const app = createApp(App);

console.log(i18n, "i18n");
zhCn.el.pagination.total = i18n.global.t('pagination.total', {total: `{total}`})
zhCn.el.pagination.pagesize = i18n.global.t('pagination.pagesize')
zhCn.el.pagination.goto = i18n.global.t('pagination.goto');
zhCn.el.pagination.pageClassifier = i18n.global.t('pagination.page');

directiveM(app);
loadMore(app);
//全局挂载
app.use(i18n)
    .use(vue3videoPlay)
    .use(ElementPlus, {locale: localStorage.getItem("lang") === 'en' ? en : zhCn})
    .use(Directives)
    .use(router)
    .use(store)
    .use(Steps)
    .use(Button)
    .provide("$DateFormat", DateFormat)
    .mount("#app");
// 自定义指令
app.directive('selectLoadMore', selectLoadMore);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

app.component("Icon", Icon);

const applyWaHideAckClass = () => {
    const v = Storage.get('wa_hide_ack')
    const hide = (v === null || v === undefined) ? true : (v === true || v === 1 || v === '1')
    try {
        document.documentElement.classList.toggle('wa-hide-ack', hide)
    } catch (e) {
    }
}

applyWaHideAckClass()

window.__setWaHideAck = (val) => {
    Storage.set('wa_hide_ack', val ? 1 : 0)
    applyWaHideAckClass()
}

export default app;
